
import TTS_pdf_header_common from "./TTS_pdf_header_common";

const TTS_pdf_headerWPQpage3 = ({pdf, setpdf}, props, wld) => {
  return <TTS_pdf_header_common pdf={pdf} pageType={3} />;
}

export default TTS_pdf_headerWPQpage3
